import React from 'react';

import { isInGame } from '~/utils';

import styles from './CommonMenu.scss';

interface CommonMenuProps {
  children?: React.ReactNode;
}

export function CommonMenu({ children }: CommonMenuProps) {
  React.useEffect(() => {
    if (isInGame) {
      return;
    }

    const { account, commonmenu, isStaging } = window.preloaded;

    const head = document.querySelector('head');
    const script = document.createElement('script');

    script.defer = true;
    script.id = 'common_menu_loader';
    script.type = 'text/javascript';

    script.setAttribute('data-ot-ignore', '');
    script.setAttribute('data-service', 'profile');
    script.setAttribute('data-project', 'mk');
    script.setAttribute('data-language', 'ru');
    script.setAttribute('data-realm', isStaging ? 'lite' : 'runet');
    script.setAttribute('data-frontend_url', commonmenu.feHost);
    script.setAttribute('data-backend_url', commonmenu.beHost);
    script.setAttribute('data-token_url', commonmenu.token);
    script.setAttribute('data-login_url', commonmenu.login);
    script.setAttribute('data-logout_url', commonmenu.logout);
    script.setAttribute('data-registration_url', commonmenu.registration);
    script.setAttribute('data-incomplete_profile_url', commonmenu.profile);
    script.setAttribute('data-notifications_enabled', String(commonmenu.notificationsEnabled));

    if (account) {
      script.setAttribute('data-user_id', String(account.id));
      script.setAttribute('data-user_name', account.nickname);
    }

    script.src = commonmenu.loader;

    head.appendChild(script);

    return () => {
      head.removeChild(script);
    };
  }, []);

  return (
    <>
      <div className={styles.wrapper} id="common_menu" />
      {children}
    </>
  );
}
